var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list-item',{on:{"click":_vm.click}},[_c('v-list-item-action',[_c('v-checkbox',{class:_vm.checkboxClass,attrs:{"color":"primary","input-value":_vm.value,"disabled":_vm.checkboxDisabled}})],1),_c('v-list-item-content',{staticClass:"align-start"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.texte)}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }